<template>
  <div>
    <!-- transition -->
    <v-slide-y-transition group tag="div" class="loan-container height-100">
      <div v-if="ready" key="content" class="content">
        <CompareLoansListSort :sortList="orderList" :sort.sync="order" class="mb-6" />

        <CompareLoansList :items="sortedItems" :loading="loading" />
      </div>

      <div v-if="ready" key="notice" class="mt-6 px-3 py-4" style="background-color: #f4faff">
        <v-layout align-start>
          <v-btn icon x-small class="mr-1">
            <v-img src="@/assets/images/icons/exclamation-circle.png" />
          </v-btn>
          <p class="font-size--12 mb-0 color--nice-black">
            상기 대출 목록은 직접 입력하신 사업 현황 정보를 기반으로 각 금융기관의 기준에 따라
            산출한 가심사 결과입니다. 추후 대출 진행 과정에서 조건이 변경되거나 대출이 거부될 수
            있습니다.
          </p>
        </v-layout>
      </div>
    </v-slide-y-transition>

    <!-- none transition -->
    <CompareLoansListFilter :items="filterList" />
  </div>
</template>

<script>
import { commaFormat } from '@/filter/number'
import { toPercentage, trimDecimalZeros } from '@/util/mathUtil'

import getCompareLoansMixin from './getCompareLoansMixin'

export default {
  mixins: [getCompareLoansMixin],

  components: {
    CompareLoansListSort: () => import('@/components/compare-loans/CompareLoansListSort.vue'),
    CompareLoansList: () => import('@/components/compare-loans/CompareLoansList.vue'),
    CompareLoansListFilter: () => import('@/components/compare-loans/CompareLoansListFilter.vue'),
  },

  data() {
    return {
      ready: false,

      filterList: [
        {
          id: 'interest',
          title: '금리(%)',
          min: 0,
          max: 0.2,
          step: 0.001,
          range: [0.04, 0.2],
          tmpRange: [0.04, 0.2],
          toLabel(value) {
            return trimDecimalZeros(toPercentage(value, 2))
          },
        },
        {
          id: 'limit',
          title: '한도(만원)',
          min: 0,
          max: 100000000,
          step: 1000000,
          range: [3000000, 100000000],
          tmpRange: [3000000, 100000000],
          toLabel(value) {
            return commaFormat(parseInt(value / 10000))
          },
        },
      ],
    }
  },

  mounted() {
    this.ready = true
  },

  async created() {
    await this.fetchItems()
  },

  computed: {
    sortedItems() {
      if (!this.loans) {
        return []
      }

      return [...this.loans].filter((item) => {
        // 이자율은 min이 기준 한도는 max가 기준
        const interest = item.minInterestRate
        const limit = item.maxLoanAmount
        const interestRange = this.filterList.find((item) => item.id === 'interest').range
        const limitRange = this.filterList.find((item) => item.id === 'limit').range
        return (
          interest >= interestRange[0] &&
          interest <= interestRange[1] &&
          limit >= limitRange[0] &&
          limit <= limitRange[1]
        )
      })
    },
  },

  methods: {},
}
</script>

<style lang="scss" scoped></style>
